import { render, staticRenderFns } from "./AffiliatorReferralCodeReport.vue?vue&type=template&id=1deb12bb"
import script from "./AffiliatorReferralCodeReport.vue?vue&type=script&lang=js"
export * from "./AffiliatorReferralCodeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports